import { Routes } from '@angular/router';
import { AuthGuard } from "./_guards/auth.guard";
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { SolicitaTrocaEscalaComponent } from './pages/solicita-troca-escala/solicita-troca-escala.component';
import { AprovaTrocaEscalaComponent } from './pages/aprova-troca-escala/aprova-troca-escala.component';
import { RecuperaSenhaComponent } from './pages/recupera-senha/recupera-senha.component';
import { NovaSenhaComponent } from './pages/nova-senha/nova-senha.component';
import { MeusDadosComponent } from './pages/meus-dados/meus-dados.component';
import { EspelhoPontoComponent } from './pages/espelho-ponto/espelho-ponto.component';
import { AlteracaoEscalaComponent } from './pages/alteracao-escala/alteracao-escala.component';
import { ConsultaPontoComponent } from './pages/consulta-ponto/consulta-ponto.component';
import { RealizarPontoComponent } from './pages/realizar-ponto/realizar-ponto.component'

export const appRoutes: Routes = [
  {
    path: '', component: HomeComponent, canActivate: [AuthGuard], children: [
      { path: 'solicitar-troca', component: SolicitaTrocaEscalaComponent, canActivate: [AuthGuard] },
      { path: 'aprovar-troca', component: AprovaTrocaEscalaComponent, canActivate: [AuthGuard] },
      { path: 'meus-dados', component: MeusDadosComponent, canActivate: [AuthGuard] },
      { path: 'espelho-ponto', component: EspelhoPontoComponent, canActivate: [AuthGuard] },
      { path: 'alteracao-escala', component: AlteracaoEscalaComponent },
      { path: 'consulta-ponto', component: ConsultaPontoComponent },
      { path: 'realizar-ponto', component: RealizarPontoComponent }
    ]
  },
  // { path: 'erro', component: ErroComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'recuperar-senha', component: RecuperaSenhaComponent },
  { path: 'redefinir-senha', component: NovaSenhaComponent },
  { path: 'nova-senha', component: NovaSenhaComponent },
];



// WEBPACK FOOTER //
// ./src/app/routes.ts